export enum CloseDialogAction {
  Cancel = 'cancel',
  Delete = 'delete',
  Refresh = 'refresh'
}
